




































































































import { Component, Vue } from 'nuxt-property-decorator'
import flatten from 'lodash/flatten'
import PageSeoMixin from '~/mixins/PageSeoMixin'
import map from '~/data/languageMap'
import WeAreIdiomaSection from '~/components/WeAreIdiomaSection.vue'
import { Locale, I18nLocale } from '~/models/LocalizationModels'

@Component({
  name: 'LanguagesSupportedPage',
  components: { WeAreIdiomaSection },
  mixins: [PageSeoMixin]
})
export default class extends Vue {
  langId = 423
  map = map

  get locale() {
    return this.$i18n.locale
  }

  get localeId() {
    // @ts-ignore
    const i18nLocale = this.$i18n.locales.find(
      // @ts-ignore
      (l: I18nLocale) => l.code === this.$i18n.locale
    )
    return i18nLocale.Locale.Id
  }

  get langs() {
    return flatten(map.map((region) => region.Languages))
  }

  get langMeta() {
    return this.langs.find((lang) => lang.Id === this.langId)
  }

  get langTexts() {
    const lang = this.langs.find((l) => l.Id === this.langId)
    return {
      Name: lang.NameTranslations[this.localeId.toLowerCase()],
      Content: lang.TextTranslations[this.localeId.toLowerCase()]
    }
  }

  selectLang(lang) {
    this.langId = lang.Id
  }

  mounted() {
    console.log(this.map)
  }
}
